import { TPAComponentProps } from '../../types';

export interface InputDialogProps extends TPAComponentProps {
  /** A title to display inside the dialog header. */
  title?: string;
  /** A subtitle to display inside the dialog header. */
  subtitle?: string | React.ReactNode;
  /** A primary button to be displayed inside the dialog footer. */
  primaryButton?: {
    text: string;
    disabled?: boolean;
    onClick(
      e:
        | React.MouseEvent<HTMLButtonElement>
        | React.KeyboardEvent<HTMLButtonElement>,
    ): void;
  };
  /** A secondary button to be displayed inside the dialog footer. */
  secondaryButton?: {
    text: string;
    disabled?: boolean;
    onClick(
      e:
        | React.MouseEvent<HTMLButtonElement>
        | React.KeyboardEvent<HTMLButtonElement>,
    ): void;
  };
  /** Whether the modal is opened */
  isOpen?: boolean;
  /** Whether to use our focus trap or to manage the focus manually. */
  manualFocus?: boolean;
  /** Adds a ref for the close button. This prop might be used when you choose the manual focus. */
  closeButtonRef?: React.RefObject<HTMLButtonElement>;
  /** Callback for when the close button is clicked */
  onClose?(): void;
  /** Children to render inside dialog */
  children?: React.ReactNode;
  /** Defines a string value that labels the dialog element. */
  ariaLabel?: string;
  /** Identifies the element that labels the dialog element. */
  ariaLabelledBy?: string;
  /** Gives the dialog an accessible description by referring to the dialog content that describes the primary message or purpose of the dialog. */
  ariaDescribedBy?: string;
  /** Defines a string value that labels the close button element. */
  closeButtonAriaLabel?: string;
  /** Identifies the element that labels the close button element. */
  closeButtonAriaLabelledby?: string;
  /** Applies full-screen mode regardless the device. */
  fullscreen?: boolean;
  /** Whether to remove the divider */
  withoutDivider?: boolean;
  /** In case the variable is set to true, InputDialog will be rendered in black and white colors */
  forceBWTheme?: boolean;
  /** A custom footer to render instead of the buttons */
  customFooter?: React.ReactNode;
}

export type InputDialogDefaultProps = Pick<InputDialogProps, 'withoutDivider'>;

export enum InputDialogDataHooks {
  PrimaryButton = 'InputDialog-primaryButton',
  SecondaryButton = 'InputDialog-secondaryButton',
}
